import * as _ from 'lodash';

export class NotificationSent {

    first: Boolean;
    second: Boolean;

    
    constructor(data?) {
        this.populate(data);
    }

    populate(data) {
        _.forOwn(data, (value, key) => {
            this[key] = value;
        });
    }

    loadFromServer(r: any) {

        if (r.first != undefined) { 
            this.first = r.first;
        }

        if (r.second != undefined) { 
            this.second = r.second;
        }

    }
}


// WEBPACK FOOTER //
// ./src/app/models/project/NotificationSent.model.ts